import type React from "react";

/**
 * Zaglavlje sitne tabele u izveštaju.
 *
 * <p>Stajalo je u četiri fajla kao četiri kopije, pa je razlika među tabovima bila pitanje toga
 * koji je zadnji menjan. Jedno mesto, jedna vrednost.
 */
export const th: React.CSSProperties = {
  textAlign: "left",
  fontSize: 11,
  color: "var(--ink-3)",
  textTransform: "uppercase",
  letterSpacing: 0.4,
  padding: "8px 10px",
  whiteSpace: "nowrap",
};
